export const ExperimentVariant = {
    VARIANT_A: "a",
    VARIANT_B: "b",
    DISABLED: "disabled",
    UNKNOWN: "unknown"
};

class Module {
    constructor() {
        let expiModel = window.expi;

        if (expiModel === null || expiModel === undefined) {
            expiModel = {};
        }
        this.expi = expiModel;
    }
    load() {
        return this.expi;
    }
    getVariant(toggleName) {
        const variant = this.expi?.[toggleName] ?? null;
        return Object.values(ExperimentVariant).includes(variant) ? variant : ExperimentVariant.UNKNOWN;
    }
}

export default new Module();
